/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_OverlineInputs */

const en_mk_team_flow_overline = /** @type {(inputs: Mk_Team_Flow_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGENT ORCHESTRATION`)
};

const id_mk_team_flow_overline = /** @type {(inputs: Mk_Team_Flow_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ORKESTRASI AGENT`)
};

/**
* | output |
* | --- |
* | "AGENT ORCHESTRATION" |
*
* @param {Mk_Team_Flow_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_overline = /** @type {((inputs?: Mk_Team_Flow_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_overline(inputs)
	return en_mk_team_flow_overline(inputs)
});